import React from 'react'
import { ArchiveIssueWarning } from 'components/canary/issue_tracking/ArchiveIssueWarning'
import type { ArchiveIssueConfirmationState } from 'components/canary/issue_tracking/useArchiveIssueConfirmation'

interface ArchiveIssueConfirmationProps {
  archiveConfirmation: ArchiveIssueConfirmationState
}

export const ArchiveIssueConfirmation: React.FC<ArchiveIssueConfirmationProps> = ({
  archiveConfirmation
}) => {
  const {
    archiveWarningIssueId,
    archiveWarningError,
    archivingIssueId,
    cancelArchiveIssue,
    confirmArchiveIssue
  } = archiveConfirmation

  if (archiveWarningIssueId == null) return null

  return (
    <ArchiveIssueWarning
      archiving={archivingIssueId != null}
      error={archiveWarningError}
      onArchive={() => { void confirmArchiveIssue() }}
      onCancel={cancelArchiveIssue}
    />
  )
}
